import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

void i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'translation',
  ns: [],
  resources: {
    en: {},
    he: {},
    ar: {}
  },
  interpolation: {
    escapeValue: false,
    prefix: '{',
    suffix: '}'
  },
  react: {
    useSuspense: false
  }
});

export default i18n;
